export default function Header() {
  return (
    <div className="flex flex-row justify-end py-4 mr-8">
      <a className="mr-4" href="mailto:krfjpe@gmail.com">Kontakt</a>
      <a href="/admin">Logg inn</a>
    </div>
  )
}